import React, { useState, useEffect } from "react";
import { FileUploadNew, showToast, LogoLoader,
  Backdrop } from "../../../../../components";
import {
  organizationImageUploadStart,
} from "../../../../../redux/slices/setting/settingsSlice";
import { useSelector, useDispatch } from "react-redux";
import { getBrandingImageStart } from "../../../../../redux/slices/setting/settingsSlice";
const Branding = () => {
  const dispatch = useDispatch();
  // const [companyLogo, setCompanyLogo] = useState([]);
  // const [socialLogo, setSocialLogo] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const { branding, loading } = useSelector((state) => state?.settings) || {};
  // console.log("branding",branding)
  const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
  useEffect(() => {
    const fetchOrganizationInfo = async () => {
      try {
        dispatch(
          getBrandingImageStart({
            coll: "Organization",
            fil: {
              uiid: {
                type: "NONE",
                value: Number(user?.data?.organizationId?.uiid),
              },
            },
            ret: "uiid name logo",
          })
        );

        // const params = {
        //   coll: "Organization",
        //   fil: {
        //     uiid: {
        //       type: "NONE",
        //       value: Number(user?.data?.organizationId?.uiid),
        //     },
        //   },
        //   ret: "uiid name logo",
        // };

        // const response = await getOrganizationLocaleInfo(params);
        // console.log("getOrganizationLocaleInfo",response)
        // if (response?.data?.data?.logo) {
        //   const companyUrl = response?.data.data.logo.company;
        //   const socialUrl = response?.data.data.logo.social;

        //   // console.log("company logo:", companyUrl, "social logo:", socialUrl);
        //   // setCompanyLogo(companyUrl);
        //   // setSocialLogo(socialUrl);
        //   const action = {
        //     company: companyUrl,
        //     social: socialUrl,
        //   };
        //   dispatch(organizationImageUploadSuccess(action));
        // }
        // console.log("Organization Info Response:", response);
      } catch (error) {
        console.error("Error fetching organization info:", error);
      }
    };

    fetchOrganizationInfo();
  }, []);

  // const fetchUrl = async (s3Key) => {
  //   try {
  //     const res = await axios.get(
  //       `${ENDPOINTS.ORGANIZATIONS.GET_IMAGE_S3_LINK}&key=${s3Key}`,
  //       { withCredentials: true }
  //     );
  //     return res.data.data;
  //   } catch (err) {
  //     return err;
  //   } finally {
  //   }
  // };

  //  const handleClickViewModal = async (data) => {
  //   setAwsUrl("");
  //   const url = await fetchUrl(data.filePath);
  //   setSelectedData(data);
  //   setViewModal(true);
  //   setAwsUrl(url);
  // };

  const handleFileUpload = async (file, logoType) => {
    if (!file) {
      // If file is deleted, we might want to handle it (e.g. clear logo in state)
      // but for now we just return to avoid the crash.
      return;
    }
    if (!ALLOWED_TYPES.includes(file.type)) {
      showToast("Please upload a valid image (PNG, JPG, or JPEG).", "error");
      return;
    }

    try {
      const organizationId = Number(user?.data?.organizationId?.uiid);
      const orgName = user?.data?.organizationId?.name;
      let previousUrl = null;

      if (logoType === "company" && branding?.company) {
        previousUrl = branding.company;
      } else if (logoType === "social" && branding?.social) {
        previousUrl = branding.social;
      }

      dispatch(
        organizationImageUploadStart({
          file,
          organizationId,
          logoType,
          previousUrl,
          orgName
        })
      );

      // if (logoType === "company") {
      //   setCompanyLogo([file]);
      // } else {
      //   setSocialLogo([file]);
      // }
    } catch (error) {
      console.error("Error uploading logo:", error);
      showToast("Failed to upload logo. Please try again.", "error");
    }
  };
  useEffect(() => {
  }, [])

  return (
    <div className="flex justify-around lg:gap-10 gap-5 items-center h-[75vh]">
      <FileUploadNew
        title="Upload Company Logo (512x512 px)"
        value={branding?.company ? [branding?.company] : []}
        width="w-md"
        // onChange={setCompanyLogo}
        onChange={(files) => handleFileUpload(files[0], "company")}
      />
      <FileUploadNew
        title="Upload Social Logo (350x150 px)"
        value={branding?.social ? [branding?.social] : []}
        width="w-md"
        // onChange={setSocialLogo}
        onChange={(files) => handleFileUpload(files[0], "social")}
      />
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Branding;
